import {intl} from '../../utils/intl';
const t = (id) => intl.formatMessage({id});

/**
 * This object holds theme definitions used when displaying ID360 profiles
 * All profiles will use the default configuration unless specified otherwise
 * 
 * Key Definitions:
 * -----------------
 * companies:       Restricts theme use to specific companies
 * name:            Display name in theme dropdown
 * hideContact:     Hides the 'Contact Representative' button if enabled
 * headerColor:     Color of the background of the header bar in profile
 * headerIconColor: Color of the icons in the profile header bar
 */

const defaultTheme = {
  name: t('ui.default'),
  headerColor: '#FAFAFA',
  headerIconColor: '#1870A1',
  pdfIconColor: 'red'
}

export default {
  default: defaultTheme,
  brixmor: {
    name: intl.formatMessage({id: 'ui.themeTemplate'}, {name: 'Brixmor Theme'}),
    companies: ['Brixmor Property Group', 'ID Plans'],
    hideContact: true,
    headerColor: '#001E62',
    headerIconColor: '#FFFFFF',
    pdfIconColor: '#FFFFFF'
  }
}